const TRACK_APPOINTMENT_STATE = {
  isVerifying: false,
  verifyingError: false,
  appointment: null,
  isSubmitting: false,
  submitingError: false,
  submittingMessage: "",
};

export default TRACK_APPOINTMENT_STATE;
